(function ($) {

	/* Document Ready */
	$(document).ready(function() {
        
        AOS.init({
            duration: 400,
            once: false,
        });
        
        /* Jarallax requirements */
        // object-fit polyfill run
        objectFitImages();

        // init Jarallax
        jarallax(document.querySelectorAll('.jarallax'));

        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });

        
        //Sidr
        $('#mobile-trigger').sidr({
            side: 'right',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<div id="mobile-menu">';
                
                sidrHtml += '<div class="sidr__header">';
                
                sidrHtml += $('.logo-mobile').html();
                
                sidrHtml += '<span class="sidr__close" aria-label="Close Menu"></span>';
                
                sidrHtml += '</div>';
                
                sidrHtml += '<div class="sidr__inner">';
                
                
                if ($('.site-header-navigation .main-navigation').length){
                    sidrHtml += '<div class="sidr__mainnav"><ul class="nav-menu">';
                    sidrHtml += $('.main-navigation').html();
                    if($('.main-navigation--right .nav-menu').length){
                        sidrHtml += $('.main-navigation--right .nav-menu').html();
                    }
                    sidrHtml += '</ul></div>';
                }
                
                sidrHtml += '<div class="sidr__subnav">';
                
                if($('.site-header .sub-navigation-links').length){
                    sidrHtml += '<ul class="sub-navigation-links">';
                    sidrHtml += $('.site-header .sub-navigation-links').html();
                    sidrHtml += '</ul>';
                }
                if($('.worship-times').length){
                    sidrHtml += '<div class="sidr__worship-times">';
                    sidrHtml += $('.worship-times').html();
                    sidrHtml += '</div>';
                }
                if($('.site-header .sub-navigation-social').length){
                    sidrHtml += '<ul class="sub-navigation-social">';
                    sidrHtml += $('.site-header .sub-navigation-social').html();
                    sidrHtml += '</ul>';
                }
                
                sidrHtml += '</div>';
                
                sidrHtml += '</div>';
                sidrHtml += '</div>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                //alert('test');
                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
            },
            onClose: function(){
                $( '.sidr-overlay' ).remove();
            }
        });
        $('.menu-item-has-children .arrow').click(function(e) {
            e.preventDefault();
            $(this).prev().toggleClass('active');
            $(this).toggleClass('active').next().slideToggle();
        });
        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
        });

	});

})(jQuery);